export const productID = 'business-banking';
export const productBPSID = 'dynamic-business-banking';
export const timeoutRedirectTo = '/banker/start';
export const firstQuestionPath = 'P1Q1';
